import * as languageMap from "shared/languageMap";

// Language-scoped URLs (e.g. /zh/dashboard) act as the source of truth on page
// load, so when the learning language changes the URL's language segment must
// be rewritten or a refresh would revert the user to the URL's language.
// Returns the updated path, or undefined if the path has no leading language
// segment or it already matches.
export const pathWithLanguageSegmentReplaced = (
  pathname: string,
  languageCode: string
): string | undefined => {
  const [, firstSegment, ...rest] = pathname.split("/");
  if (
    firstSegment &&
    firstSegment !== languageCode &&
    languageMap.map[firstSegment]
  ) {
    return ["", languageCode, ...rest].join("/");
  }
  return undefined;
};

// Returns the value of the query string variable with the given key,
// or an empty string if it doesn't exist
//
// copied from https://gist.github.com/1771618
export const getUrlVar = (key, queryString?: string) => {
  queryString = queryString || window.location.search;
  const result = new RegExp(key + "=([^&]*)", "i").exec(queryString);
  return (result && decodeURIComponent(result[1])) || "";
};
